import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../../common/utils/getApiReducer';

import {
  CANCEL_FOLLOW_UP_SESSION_FOR_ADMIN,
  EDIT_FOLLOW_UP_DATA,
  GET_FOLLOW_UP_DATA,
  GET_TATHATA_FOLLOW_UPS,
  RESPOND_TO_FOLLOW_UP_REQUEST,
} from './actions';

const followUpDataReducer = getApiReducer(GET_FOLLOW_UP_DATA);
const followUpData = (state, action) => {
  state = followUpDataReducer(state, action);

  if (action.type === `${EDIT_FOLLOW_UP_DATA}_SUCCESS`) {
    return state.set('data', fromJS(action.json));
  }

  return state;
};

const followUpsReducer = getApiReducer(GET_TATHATA_FOLLOW_UPS);
const followUps = (state, action) => {
  const nextState = followUpsReducer(state, action);

  if (action.type === `${RESPOND_TO_FOLLOW_UP_REQUEST}_SUCCESS`) {
    const index = nextState.get('data').findIndex(item => item.get('id') === action.json.id);

    return nextState.mergeIn(['data', index], fromJS(action.json));
  }

  if (action.type === `${CANCEL_FOLLOW_UP_SESSION_FOR_ADMIN}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.sessionId, 10));

    return nextState.deleteIn(['data', index]);
  }

  return nextState;
};

export default combineReducers({
  cancelSession: getApiReducer(CANCEL_FOLLOW_UP_SESSION_FOR_ADMIN),
  editFollowUpData: getApiReducer(EDIT_FOLLOW_UP_DATA),
  followUpData,
  followUps,
  respondToFollowUpRequest: getApiReducer(RESPOND_TO_FOLLOW_UP_REQUEST),
});



// WEBPACK FOOTER //
// ./src/follow-ups/redux/reducers.js